const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      fill: "#3f9c35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.71,8.86l-2.4,2.4c-.27,.27-.09,.74,.3,.74h1.54c0,2.84-2.31,5.16-5.16,5.16-.68,0-1.34-.13-1.93-.38-.31-.13-.66-.03-.89,.2-.44,.44-.28,1.18,.29,1.41,.78,.32,1.64,.49,2.54,.49,3.8,0,6.87-3.08,6.87-6.87h1.54c.39,0,.58-.46,.3-.73l-2.4-2.4c-.16-.17-.44-.17-.6,0Zm-10.87,3.14c0-2.84,2.31-5.16,5.16-5.16,.68,0,1.34,.13,1.93,.38,.31,.13,.66,.03,.89-.2,.44-.44,.28-1.18-.29-1.41-.78-.32-1.64-.49-2.54-.49-3.8,0-6.87,3.08-6.87,6.87h-1.54c-.39,0-.58,.46-.3,.73l2.4,2.4c.17,.17,.44,.17,.61,0l2.4-2.4c.27-.27,.08-.73-.31-.73h-1.54Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading-icon.362b3f21a55646a32246a6e99c00a55c.svg";
export { ForwardRef as ReactComponent };